import { Component } from '@angular/core';
import { AppService } from '../service/app.service';


@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent {
  mainNavigationMode: string;
  mainNavigationOpened: boolean;

  constructor(
    private appService: AppService) {

    this.appService.mainNavigationOpened.subscribe((opened) => {
      this.mainNavigationOpened = opened;
    });

    this.appService.mainNavigationMode.subscribe((mode) => {
      this.mainNavigationMode = mode;
    });

  }
}
